import { Icon } from '@chakra-ui/react';

export default function SFDollarSignCircleIcon(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width={4}
      height='17px'
      viewBox='0 0 16 17'
      fill='currentColor'
      {...props}
    >
      <path d='M8 16.328c-4.352 0-7.969-3.617-7.969-7.969C.031 4 3.641.391 7.992.391 12.352.39 15.97 4 15.97 8.359c0 4.352-3.61 7.97-7.969 7.97M8 15a6.615 6.615 0 0 0 6.64-6.64 6.62 6.62 0 0 0-6.648-6.641 6.6 6.6 0 0 0-6.625 6.64A6.61 6.61 0 0 0 8 15m-.008-2.18a.353.353 0 0 1-.367-.367v-.562c-1.047-.102-1.922-.68-2.14-1.578a.8.8 0 0 1-.04-.243c0-.273.188-.46.453-.46.235 0 .391.124.485.39.125.523.539.914 1.242 1.016V8.703l-.055-.015c-1.304-.305-1.976-.899-1.976-1.891 0-1.063.843-1.805 2.031-1.938V4.32c0-.218.156-.367.367-.367s.367.149.367.367v.54c1 .117 1.805.695 2.008 1.538.016.086.04.165.04.243 0 .273-.196.46-.462.46-.25 0-.398-.148-.476-.382-.156-.524-.547-.86-1.11-.961v2.18l.11.023c1.36.242 2.047.883 2.047 1.945 0 1.18-.946 1.883-2.157 2v.547a.353.353 0 0 1-.367.367m-.367-5.078V5.758c-.664.117-1.07.515-1.07.992 0 .46.312.773 1.015.977zm.734 1.149v2.125c.797-.094 1.188-.508 1.188-1.055 0-.5-.258-.82-1.016-1.031z' />
    </Icon>
  );
}
